// Условное изображение бумаги: без текста, значков файла и элементов управления.
export default function BlankPaperPreview({ className = "" }) {
    return (
        <svg aria-hidden="true" viewBox="0 0 180 230" fill="none" className={className}>
            <rect x="28" y="24" width="136" height="192" rx="3" fill="#E1E4EB" />
            <rect x="21" y="17" width="136" height="192" rx="3" fill="#F1F3F7" stroke="#CBD2DE" />
            <rect x="14" y="10" width="136" height="192" rx="3" fill="white" stroke="#AAB7CD" strokeWidth="2" />
        </svg>
    );
}
